/**
 * 세션 영역 — 운영자(/admin)·사용자(/app)는 **다른 쿠키**를 쓴다 (260917-realm-sessions-impersonation).
 * 역할과 영역은 1:1 이다. 대행사 영역(/agency)은 261013-account-brand-membership 에서 없앴다 —
 * 옛 `x-geo-realm: agency` 는 app 으로 읽고, 옛 대행사 세션은 영역이 안 맞아 통하지 않는다.
 * `__Host-` 쿠키는 Path=/ 가 강제라 쿠키가 모든 /api 요청에 함께 실린다. 어느 쪽을 읽을지는 요청이 알려 준다.
 */
export const REALMS = ['app', 'admin'] as const;
export type Realm = (typeof REALMS)[number];

/** web 의 call() 이 모든 API 요청에 싣는다. 없거나 모르는 값이면 app */
export const REALM_HEADER = 'x-geo-realm';

/** 헤더를 실을 수 없는 `<a href>` GET(샘플 원본 파일)에서만 받는다 — `?realm=admin` */
export const REALM_QUERY = 'realm';

/** 대리 로그인 탭의 토큰. **이 헤더가 있으면 서버는 쿠키를 보지 않는다** — 무효여도 쿠키로 폴백하지 않는다 */
export const IMPERSONATION_HEADER = 'x-geo-impersonation';
